module.exports = __webpack_public_path__ + "static/media/Header3.b4285ee9.jpg";